// Static seed catalog for the Template picker (plan §5.4). Loaded at bundle
// time — no network. Each entry is the raw JSON from the sibling files.
//
// To add a new template:
//   1. drop the .json next to this file matching the shape in _schema.md
//   2. import + push it into TEMPLATES below
//   3. (optional) extend the picker thumbnail/preview wiring
//
// Order of TEMPLATES is the order rendered in the picker.
import linearWatchQuiz from "./linear-watch-quiz.json";
import branchingCaseStudy from "./branching-case-study.json";
import flashcardDeck from "./flashcard-deck.json";
import mixedQuiz from "./mixed-quiz.json";
import interactiveVideoStarter from "./interactive-video-starter.json";
import interactiveVideoDeep from "./interactive-video-deep.json";
import hotspotTour from "./hotspot-tour.json";
import questionSetDrill from "./question-set-drill.json";
import truefalseBasic from "./truefalse-basic.json";

const TEMPLATES = [
  linearWatchQuiz,
  branchingCaseStudy,
  flashcardDeck,
  mixedQuiz,
  interactiveVideoStarter,
  interactiveVideoDeep,
  hotspotTour,
  questionSetDrill,
  truefalseBasic,
];

export default TEMPLATES;
export { TEMPLATES };

// Lookup by id for the picker's click → apply path.
export function getTemplateById(id) {
  return TEMPLATES.find((t) => t && t.id === id) || null;
}
